/* eslint-disable */
/**
 * AUTOGENERATED — DO NOT EDIT. (CONTEXT-DOCS.md §P0)
 *
 * Generated from: backend/api/sls/lambda-python3.9/layers/stepflow_core/python/stepflow_core/document_extract.py
 * (``room_upload_extensions`` / ``ROOM_UPLOAD_MAX_BYTES``). Regenerate: ``python3 scripts/gen_upload_types.py``.
 * The upload-URL route refuses anything else (415) — this copy only lets the picker filter + explain up front.
 */

/** Every file type a person may share in a room (we can turn it into context text; archives are unpacked). */
export const ROOM_UPLOAD_EXTENSIONS: readonly string[] = [
  '.txt',
  '.md',
  '.markdown',
  '.mdx',
  '.rst',
  '.csv',
  '.tsv',
  '.log',
  '.json',
  '.jsonl',
  '.ndjson',
  '.geojson',
  '.xml',
  '.yaml',
  '.yml',
  '.toml',
  '.ini',
  '.cfg',
  '.conf',
  '.properties',
  '.env',
  '.html',
  '.htm',
  '.xhtml',
  '.svg',
  '.tf',
  '.tfvars',
  '.hcl',
  '.bicep',
  '.gradle',
  '.dockerfile',
  '.py',
  '.js',
  '.jsx',
  '.ts',
  '.tsx',
  '.mjs',
  '.cjs',
  '.go',
  '.rs',
  '.rb',
  '.java',
  '.kt',
  '.kts',
  '.scala',
  '.c',
  '.h',
  '.cc',
  '.cpp',
  '.hpp',
  '.cs',
  '.php',
  '.swift',
  '.sh',
  '.bash',
  '.zsh',
  '.ps1',
  '.sql',
  '.graphql',
  '.gql',
  '.proto',
  '.r',
  '.pl',
  '.lua',
  '.groovy',
  '.vue',
  '.svelte',
  '.docx',
  '.xlsx',
  '.pptx',
  '.pdf',
  '.png',
  '.jpeg',
  '.jpg',
  '.tiff',
  '.tif',
  '.zip',
  '.tar',
  '.tar.gz',
  '.tgz',
];

/** One size cap for room uploads (bytes). */
export const ROOM_UPLOAD_MAX_BYTES = 104857600;

/** The ``accept`` attribute for a file input. */
export const ROOM_UPLOAD_ACCEPT = ROOM_UPLOAD_EXTENSIONS.join(',');
